import { inject, Injectable } from '@angular/core';

import { AuthenticationService } from '~/core/services/authentication.service';
import { AffiliationService } from '~/core/services/affiliation.service';
import { StorageService } from '~/core/services/storage.service';
import { DialogOrchestratorService } from '~/core/services/dialog-orchestrator.service';

@Injectable({
  providedIn: 'root',
})
export class LoadPriorityService {
  private auth = inject(AuthenticationService);
  private affiliationService = inject(AffiliationService);
  private readonly dialogOrchestrator = inject(DialogOrchestratorService);

  loadPriorityServices() {
    this.dialogOrchestrator.showStartupDialogs();
  }

  async setAffiliateInfo() {
    const url = new URL(window.location.href);
    let affiliateId: string;
    if (url.searchParams.has('affiliate_id')) {
      affiliateId = url.searchParams.get('affiliate_id');
    } else if (url.searchParams.has('id')) {
      affiliateId = url.searchParams.get('id');
    }

    if (affiliateId) {
      try {
        // Inicializar a chave no IndexedDB
        StorageService.initializeKey('AFFILIATED', affiliateId);

        let ngx_campaign_id = null;
        let ngx_source_id = null;

        if (url.searchParams.has('ngx_campaign_id')) {
          ngx_campaign_id = url.searchParams.get('ngx_campaign_id');
        }
        if (url.searchParams.has('ngx_source_id')) {
          ngx_source_id = url.searchParams.get('ngx_source_id');
        }

        // Configurar o afiliado
        await this.auth.setAffiliated(JSON.stringify({ id: affiliateId }));
        this.affiliationService
          .postAffiliationClick({
            user: affiliateId,
            ngx_campaign_id,
            ngx_source_id,
          })
          .subscribe();
      } catch (error) {
        console.error('Erro ao salvar afiliado:', error);
      }
    }
  }
}
